import { html } from "htm/preact/index.js";
import SvgIcon from "../svg-icon/svg-icon";

/**
 * @typedef {object} ButtonProps
 * @property {import("preact").ComponentChildren} children
 * @property {string[]} classes
 * @property {boolean} disabled
 * @property {string} href?
 * @property {string} icon
 * @property {boolean} isLoading
 * @property {Function} onClick
 * @property {string} tagName
 * @property {string} theme
 * @property {string} size
 * @property {string} style
 * @property {string} type
 */

/**
 * @param {ButtonProps} props
 * @returns {import("preact").VNode}
 */
function Button({
  children,
  classes = [],
  disabled,
  href,
  icon,
  isLoading,
  tagName = "button",
  theme = "primary",
  size,
  style,
  type = "button",
  onClick,
  target,
}) {
  const buttonClasses = ["moxies-button", ...classes];
  switch (theme) {
    case "primary":
      buttonClasses.push("moxies-button-green");
      break;
    case "copper":
      buttonClasses.push("moxies-button-copper");
      break;
    case "white":
      buttonClasses.push("moxies-button-white");
      break;
  }

  if (disabled) {
    buttonClasses.push("moxies-button-disabled");
  }

  if (style === "outline") {
    buttonClasses.push("moxies-button-outline");
  } else {
    buttonClasses.push("moxies-button-standard");
  }

  if (size === "lg") {
    buttonClasses.push("moxies-button-lg");
  }

  const inner = html` <span class="moxies-button__bg"></span>
    <span class="moxies-button__label">
      ${children}
      <span class="moxies-button__icon">
        ${
    isLoading
      ? html`<mx-spinner></mx-spinner>`
      : html`<${SvgIcon} icon=${icon} />`
  }
      </span>
    </span>`;


  if (tagName === "a") {
    return html`<a target="_blank" href=${href} class="${buttonClasses.join(" ")}}">
      ${inner}
    </a>`;
  }

  return html` <button
    class=${buttonClasses.join(" ")}
    disabled=${disabled || isLoading ? "disabled" : ""}
    type=${type}
    disabled=${isLoading}
    onClick=${onClick}
  >
    ${inner}
  </button>`;
}

export default Button;
